<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData, modal} from 'general/store';
    import {BACKGROUND_COLOR, TEMPLATE} from 'general/constants';
    import Form from 'general/components/form/email/Form.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import Timer from 'desktop/components/timer/Timer.svelte';
    import PeopleSubscribedBadge from 'desktop/components/peopleSubscribedBadge/PeopleSubscribedBadge.svelte';
    import Description from 'general/components/description/Description.svelte';
    import OpacityItem from 'general/components/flip/opacityItem/OpacityItem.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;

    const isLight = $dyData.side.main?.backgroundColor === BACKGROUND_COLOR.LIGHT;
</script>

<OpacityItem delayIn={0}>
    <div
        class={s.main}
        class:s.light={isLight}
        class:s.colored={!isLight}
        style="margin-top: {$dyData.side.main?.marginTop || 0}"
    >
        {#if $dyData.counterDown}
            <Timer />
        {/if}
        {#if $dyData.peopleSubscribed}
            <PeopleSubscribedBadge />
        {/if}
        <Description template={TEMPLATE.SQUARE_EXIT} value={$dyData.description.main} />
        <Form
            {instance}
            label="Enter Email Address Here"
            offerGiven={$dyData.offerGiven}
            template={TEMPLATE.SQUARE_EXIT}
            marginBottom="22px"
        />
        <ActionButton
            handleClick={modal.close}
            marginTop="20px"
            fontSize="17px"
            children="No thanks, remind me later"
            color="light"
            template={TEMPLATE.SQUARE_EXIT}
        />
        <Policy padding="0 25px" />
    </div>
</OpacityItem>
